<template>
  <div>
    <vue-c3 :handler="handler"></vue-c3>
  </div>
</template>

<script>

import Vue from 'vue';
import VueC3 from 'vue-c3';
require('c3/c3.css');

export default {
  name: 'WeightMacroChart',
  components: {
    VueC3
  },
  props: {
    kcalsKilo: {
      type: Number,
      default: 0
    },
    proteinKilo: {
      type: Number,
      default: 0
    },
    fatKilo: {
      type: Number,
      default: 0
    },
    carbsKilo: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      handler: new Vue(),
      colors: [
        '#9765E0',
        '#00C2BA',
        '#C4CC52'
      ]
    };
  },
  mounted () {
    this.draw();
  },
  methods: {
    draw () {
      const options = {
        data: {
          columns: [
            ['Protein/kg', this.proteinKilo],
            ['Fat/kg', this.fatKilo],
            ['Carbs/kg', this.carbsKilo]
          ],
          type: 'donut',
          names: {
            'Protein/kg': this.$t('health.summary.protein'),
            'Fat/kg': this.$t('health.summary.fat'),
            'Carbs/kg': this.$t('health.summary.carbs')
          }
        },
        donut: {
          title: this.$t('health.summary.weightTitle', {value: this.kcalsKilo}),
          label: {
            format: function (value) {
              return value;
            }
          }
        },
        color: {
          pattern: this.colors
        },
        tooltip: {
          format: {
            value: function (value) {
              return value + '/kg';
            }
          }
        }
      };
      this.handler.$emit('init', options);
    }
  },
  watch: {
    proteinKilo: {
      handler: function () {
        this.draw();
      }
    },
    fatKilo: {
      handler: function () {
        this.draw();
      }
    },
    carbsKilo: {
      handler: function () {
        this.draw();
      }
    },
    kcalsKilo: {
      handler: function () {
        this.draw();
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/summary/WeightMacroChart.vue